{
    "Accessibility menu": "అందుబాటు మెనూ",
    "Close": "మూసివేయండి",
    "Content adjustments": "విషయ సర్దుబాట్లు",
    "Navigation adjustments": "నావిగేషన్ సర్దుబాట్లు",
    "Text Align": "Text Align",
    "Align Left": "ఎడమవైపు సరిచేయండి",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "ఫాంట్ పరిమాణాన్ని సర్దుబాటు చేయండి",
    "Highlight Title": "శీర్షికను హైలైట్ చేయండి",
    "Highlight Links": "లింక్‌లను హైలైట్ చేయండి",
    "Readable Font": "చదవగలిగే ఫాంట్",
    "Colour adjustments": "రంగు సర్దుబాట్లు",
    "Dark Contrast": "చీకటి వ్యత్యాసం",
    "Light Contrast": "తేలిక వ్యత్యాసం",
    "High Contrast": "ఎక్కువ వ్యత్యాసం",
    "High Saturation": "ఎక్కువ సంతృప్తి",
    "Low Saturation": "తక్కువ సంతృప్తి",
    "Monochrome": "ఏకరంగు",
    "Tools": "సాధనాలు",
    "Reading Guide": "చదవడం గైడ్",
    "Big Cursor": "పెద్ద కర్సర్",
    "Increase Font Size": "ఫాంట్ పరిమాణాన్ని పెంచండి",
    "Decrease Font Size": "ఫాంట్ పరిమాణాన్ని తగ్గించండి",
    "Letter Spacing": "అక్షరాల మధ్య ఖాళీ",
    "Line Height": "పంక్తి ఎత్తు",
    "Font Weight": "ఫాంట్ బరువు",
    "Dyslexia Font": "డిస్లెక్సియా ఫాంట్",
    "Language": "భాష",
    "Accessibility widget": "అందుబాటు మెనూని తెరవండి",
    "Accessibility Profiles": "అందుబాటు ప్రొఫైల్‌లు",
    "Cognitive Disability": "జ్ఞాన సంబంధిత వైకల్యం",
    "Seizure Safe": "పట్టు సురక్షితం",
    "Accessibility statement": "అందుబాటు ప్రకటన",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "యానిమేషన్‌లను ఆపండి",
    "Animation paused": "యానిమేషన్ పాజ్ చేయబడింది",
    "Reset all settings": "సెట్టింగ్‌లను రీసెట్ చేయండి",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
